export default [
    {
      path: '/summary',
      name: 'summary',
      component: () => import('@/views/sft/Summary.vue'),
    },
  ]